// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable no-invalid-position-declaration */
.hide {
  display: none;
}

@media all and (max-width: 2463px) {
  .hide-xxl-down {
    display: none;
  }
}

@media all and (min-width: 2463px) {
  .hide-xxl-up {
    display: none;
  }
}

@media all and (max-width: 1183px) {
  .hide-xl-down {
    display: none;
  }
}

@media all and (min-width: 1183px) {
  .hide-xl-up {
    display: none;
  }
}

@media all and (max-width: 928px) {
  .hide-lg-down {
    display: none;
  }
}

@media all and (min-width: 928px) {
  .hide-lg-up {
    display: none;
  }
}

@media all and (max-width: 927px) {
  .hide-md-down {
    display: none;
  }
}

@media all and (min-width: 927px) {
  .hide-md-up {
    display: none;
  }
}

@media all and (max-width: 767px) {
  .hide-sm-down {
    display: none;
  }
}

@media all and (min-width: 767px) {
  .hide-sm-up {
    display: none;
  }
}

@media all and (max-width: 320px) {
  .hide-xs-down {
    display: none;
  }
}

@media all and (min-width: 320px) {
  .hide-xs-up {
    display: none;
  }
}

@media all and (max-width: 767px) {
  :host(.hide-sm-down) {
    display: none;
  }
}

.ids-popup-menu:not([hidden]) {
  display: block;
  z-index: var(--ids-z-index-160);
}`, "",{"version":3,"sources":["webpack://./src/themes/mixins/ids-hide-mixin.scss","webpack://./src/components/ids-popup-menu/ids-popup-menu.scss"],"names":[],"mappings":"AAAA,sDAAA;AAIA;EACE,aAAA;ACFF;;ADME;EADF;IAEI,aAAA;ECFF;AACF;;ADYE;EADF;IAEI,aAAA;ECRF;AACF;;ADkBE;EADF;IAEI,aAAA;ECdF;AACF;;ADwBE;EADF;IAEI,aAAA;ECpBF;AACF;;AD8BE;EADF;IAEI,aAAA;EC1BF;AACF;;ADoCE;EADF;IAEI,aAAA;EChCF;AACF;;AD0CE;EADF;IAEI,aAAA;ECtCF;AACF;;ADgDE;EADF;IAEI,aAAA;EC5CF;AACF;;ADsDE;EADF;IAEI,aAAA;EClDF;AACF;;AD4DE;EADF;IAEI,aAAA;ECxDF;AACF;;ADkEE;EADF;IAEI,aAAA;EC9DF;AACF;;ADwEE;EADF;IAEI,aAAA;ECpEF;AACF;;ADoCE;EC7GF;ID8GI,aAAA;EChCF;AACF;;AA1EE;EACE,cAAA;EACA,+BAAA;AA6EJ","sourcesContent":["/* stylelint-disable no-invalid-position-declaration */\n@use '../../themes/mixins/ids-core-mixins' as *;\n\n// Includes Hidden Classes and Mixins for hiding elements at breakpoints\n.hide {\n  display: none;\n}\n\n.hide-xxl-down {\n  @media all and (max-width: $breakpoint-xxl) {\n    display: none;\n  }\n}\n\n@mixin hide-xxl-down {\n  @media all and (max-width: $breakpoint-xxl) {\n    display: none;\n  }\n}\n\n.hide-xxl-up {\n  @media all and (min-width: $breakpoint-xxl) {\n    display: none;\n  }\n}\n\n@mixin hide-xxl-up {\n  @media all and (min-width: $breakpoint-xxl) {\n    display: none;\n  }\n}\n\n.hide-xl-down {\n  @media all and (max-width: $breakpoint-xl) {\n    display: none;\n  }\n}\n\n@mixin hide-xl-down {\n  @media all and (max-width: $breakpoint-xl) {\n    display: none;\n  }\n}\n\n.hide-xl-up {\n  @media all and (min-width: $breakpoint-xl) {\n    display: none;\n  }\n}\n\n@mixin hide-xl-up {\n  @media all and (min-width: $breakpoint-xl) {\n    display: none;\n  }\n}\n\n.hide-lg-down {\n  @media all and (max-width: $breakpoint-lg) {\n    display: none;\n  }\n}\n\n@mixin hide-lg-down {\n  @media all and (max-width: $breakpoint-lg) {\n    display: none;\n  }\n}\n\n.hide-lg-up {\n  @media all and (min-width: $breakpoint-lg) {\n    display: none;\n  }\n}\n\n@mixin hide-lg-up {\n  @media all and (min-width: $breakpoint-lg) {\n    display: none;\n  }\n}\n\n.hide-md-down {\n  @media all and (max-width: $breakpoint-md) {\n    display: none;\n  }\n}\n\n@mixin hide-md-down {\n  @media all and (max-width: $breakpoint-md) {\n    display: none;\n  }\n}\n\n.hide-md-up {\n  @media all and (min-width: $breakpoint-md) {\n    display: none;\n  }\n}\n\n@mixin hide-md-up {\n  @media all and (min-width: $breakpoint-md) {\n    display: none;\n  }\n}\n\n.hide-sm-down {\n  @media all and (max-width: $breakpoint-sm) {\n    display: none;\n  }\n}\n\n@mixin hide-sm-down {\n  @media all and (max-width: $breakpoint-sm) {\n    display: none;\n  }\n}\n\n.hide-sm-up {\n  @media all and (min-width: $breakpoint-sm) {\n    display: none;\n  }\n}\n\n@mixin hide-sm-up {\n  @media all and (min-width: $breakpoint-sm) {\n    display: none;\n  }\n}\n\n.hide-xs-down {\n  @media all and (max-width: $breakpoint-xs) {\n    display: none;\n  }\n}\n\n@mixin hide-xs-down {\n  @media all and (max-width: $breakpoint-xs) {\n    display: none;\n  }\n}\n\n.hide-xs-up {\n  @media all and (min-width: $breakpoint-xs) {\n    display: none;\n  }\n}\n\n@mixin hide-xs-up {\n  @media all and (min-width: $breakpoint-xs) {\n    display: none;\n  }\n}\n\n@mixin breakpoint-xs-down {\n  @media all and (max-width: $breakpoint-xs) {\n    @content;\n  }\n}\n","@use '../../themes/mixins/ids-hide-mixin.scss' as hide;\n\n:host(.hide-sm-down) {\n  @include hide.hide-sm-down();\n}\n\n.ids-popup-menu {\n  &:not([hidden]) {\n    display: block;\n    z-index: var(--ids-z-index-160);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
